export default "__VITE_ASSET__4cgQS7qi__"